import { CATEGORIES } from './constants';

export const getTimelineData = (messages, studentName, selectedCategory) => {
  return messages
    .filter(msg => 
      msg.names.includes(studentName) && 
      (selectedCategory === CATEGORIES.ALL || msg.category === selectedCategory)
    )
    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
};

export const formatTimelineDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
};

export const getTimelinePosition = (date, firstDate, lastDate) => {
  if (!firstDate || !lastDate) return 50;
  const total = lastDate.getTime() - firstDate.getTime();
  if (total === 0) return 50;
  const current = date.getTime() - firstDate.getTime();
  return Math.min(Math.max((current / total) * 100, 10), 90); // Keep within 10-90% range
};